import React from 'react'
import HomePresenter from './HomePresenter'
import { moviesApi } from '../../api'

export default class HomeContainer extends React.Component {
    state = {
        nowPlaying: null,
        upcoming: null,
        popular: null,
        error: null,
        loading: true,
        randomId: ''
    }

    async componentDidMount() {
        try {
            const { data: { results: nowPlaying } } = await moviesApi.nowPlaying()
            const { data: { results: upcoming } } = await moviesApi.upcoming()
            const { data: { results: popular } } = await moviesApi.popular()
            if (popular && popular.length > 0) {
                const random = Math.floor(Math.random() * popular.length)
                this.setState({ nowPlaying, upcoming, popular, randomId: random })
            }
        } catch (error) {
            this.setState({ error: "Can't find movie information." })
        } finally {
            this.setState({ loading: false })
        }
    }
    render() {
        const { nowPlaying, upcoming, popular, error, loading, randomId } = this.state

        return (
            <HomePresenter nowPlaying={nowPlaying} upcoming={upcoming} popular={popular} error={error} loading={loading} randomId={randomId} />
        )
    }
}


